module.exports = __webpack_public_path__ + "fonts/frame_118.svg";